import React from 'react';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useBrpClubDealer } from 'services/Data/DealerServices';

const ClubDealerVerificationModal = ({ show, onConfirmCurrentDealer, onSwitchDealer }) => {
  const { t } = useTranslation();
  const accountReducer = useSelector(state => state.AccountReducer);
  const activeDealerId = accountReducer?.profile?.temporaryDealer_Id;
  const { data: dealer } = useBrpClubDealer(activeDealerId);

  const dealerName = dealer?.customerName || t('dealer');
  const dealerNumber = dealer?.identifier;
  const dealerPhone = dealer?.phoneNumber;
  const dealerLocation = [dealer?.city, dealer?.region?.internalName, dealer?.postalCode].filter(Boolean).join(', ');

  return (
    <Dialog
      open={show}
      onClose={onConfirmCurrentDealer}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
          border: '1px solid #2f2f2f',
          boxShadow: '0 14px 32px rgba(0, 0, 0, 0.28)',
          overflow: 'hidden',
        },
      }}>
      <DialogTitle
        sx={{
          backgroundColor: '#ffffff',
          color: '#111111',
          fontWeight: 700,
          fontSize: '1.15rem',
          pb: 1.25,
          borderBottom: '1px solid #ececec',
        }}>
        {t('verifyDealer')}
      </DialogTitle>

      <DialogContent sx={{ pt: '16px !important', backgroundColor: '#ffffff' }}>
        <Box mb={2} sx={{ p: 1.5, borderRadius: 1.5, border: '1px solid #f0e1a0', backgroundColor: '#fff9e6' }}>
          <Typography variant="body2" sx={{ color: '#1f1f1f' }}>
            {t('dealer-select')}
          </Typography>
        </Box>

        <Box
          sx={{
            border: '1px solid #ede4bd',
            borderRadius: 2,
            background: 'linear-gradient(135deg, #fffdf4 0%, #fff9dd 100%)',
            p: 2,
          }}>
          <Typography
            sx={{ fontSize: 12, fontWeight: 700, letterSpacing: '0.04em', textTransform: 'uppercase', color: '#626b78' }}>
            {t('dealer')}
          </Typography>
          <Typography sx={{ mt: 0.5, fontSize: 26, lineHeight: 1.2, fontWeight: 800, color: '#0f172a' }}>
            {dealerName}
          </Typography>

          {dealerNumber ? (
            <Typography
              sx={{
                mt: 1.25,
                display: 'inline-flex',
                fontSize: 13,
                fontWeight: 700,
                color: '#111111',
                background: '#FFD200',
                border: '1px solid #e0b900',
                borderRadius: 99,
                px: 1.25,
                py: 0.75,
              }}>
              {t('dealer')} #{dealerNumber}
            </Typography>
          ) : null}

          {(dealerLocation || dealerPhone) && (
            <Box sx={{ mt: 2, border: '1px solid #eceef3', borderRadius: 1.5, background: '#f7f9fc', p: 1.5 }}>
              {dealerLocation ? (
                <Typography sx={{ fontSize: 13, color: '#344054', mb: dealerPhone ? 0.5 : 0 }}>
                  <strong style={{ color: '#0f172a' }}>{t('address')}:</strong> {dealerLocation}
                </Typography>
              ) : null}
              {dealerPhone ? (
                <Typography sx={{ fontSize: 13, color: '#344054' }}>
                  <strong style={{ color: '#0f172a' }}>{t('appModule.phone')}:</strong> {dealerPhone}
                </Typography>
              ) : null}
            </Box>
          )}
        </Box>
      </DialogContent>

      <DialogActions sx={{ px: 3, py: 2, borderTop: '1px solid #ececec', backgroundColor: '#fafafa' }}>
        <Button
          onClick={onConfirmCurrentDealer}
          variant="contained"
          sx={{
            backgroundColor: '#FFD200',
            color: '#111111',
            fontWeight: 700,
            '&:hover': { backgroundColor: '#e8be00' },
          }}>
          {t('continue')}
        </Button>
        <Button
          onClick={onSwitchDealer}
          variant="outlined"
          sx={{
            color: '#111111',
            borderColor: '#c9c9c9',
            '&:hover': { borderColor: '#111111', backgroundColor: '#f4f4f4' },
          }}>
          {t('notYourDealer')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ClubDealerVerificationModal;
